import type { PickByValueExact } from 'utility-types'

import { assert } from '../../../utils'

import { type AppState, ConnectwareError, ConnectwareErrorType, selectUsersManagement, type UsersManagement } from '../../../domain'

import { initialState } from '../..'
import { TabManagementUsecase } from './Tab'

export abstract class ViewFormUsecase<Form> extends TabManagementUsecase {
    protected abstract readonly formName: keyof PickByValueExact<UsersManagement, Form | null>

    protected abstract readonly selectForm: (s: AppState) => Form | null

    private getHiddenFormsState (): Partial<UsersManagement> {
        const { roleCreation, roleUpdating, userUpdating, userCreation, registryRequest } = selectUsersManagement(initialState)
        const hiddenFormsState: Omit<UsersManagement, 'selected' | 'users' | 'roles' | 'permissions' | 'registry' | 'viewPermission'> = {
            roleCreation,
            roleUpdating,
            userUpdating,
            userCreation,
            registryRequest,
        }
        return hiddenFormsState
    }

    protected setForm (form: Form): void {
        this.setUsersManagement({ ...this.getHiddenFormsState(), [this.formName]: form })
    }

    protected getNullableForm (): Form | null {
        return this.selectForm(this.getState())
    }

    protected getForm (): Form {
        const form = this.getNullableForm()
        assert(form, new ConnectwareError(ConnectwareErrorType.STATE, 'Can not retrieve form'))
        return form
    }

    close (): void {
        this.setUsersManagement(this.getHiddenFormsState())
    }
}
